import { createFileRoute } from '@tanstack/react-router';
import ResourcesHome from '@pages/Resources/ResourcesHome';

export const Route = createFileRoute('/home/')({
  component: ResourcesHome,
});
